import {
    AddUserIcon,
    ArchiveIcon,
    CalendarIcon,
    DeleteIcon,
    EditIcon,
    KeyIcon,
    LockIcon,
    MinusIcon,
    RemoveIcon,
    RemoveUserIcon,
    SettingsIcon,
    ShareIcon
} from "@hopper-ui/icons";
import type { BulkAction, ODataActivityType } from "../api/types.ts";
import { RemoveKeyIcon, ScissorsIcon } from "@sg-protect/components";
import type { ComponentType } from "react";

export const ACTIVITY_TYPE_ICON = {
    sharingLinkDeleted: DeleteIcon,
    groupOwnerAdded: AddUserIcon,
    groupMemberAdded: AddUserIcon,
    groupOwnerRemoved: RemoveUserIcon,
    groupMemberRemoved: RemoveUserIcon,
    groupGuestRemoved: RemoveUserIcon,
    principalRemovedFromSPGroup: RemoveUserIcon,
    directPermissionRemoved: KeyIcon,
    siteCollectionAdminRemoved: RemoveKeyIcon,
    groupDeleted: DeleteIcon,
    groupVisibilityUpdated: LockIcon,
    siteDeleted: DeleteIcon,
    siteArchived: ArchiveIcon,
    archivedSiteDeleted: DeleteIcon,
    userLicenseUnassigned: RemoveUserIcon,
    everyoneExceptExternalUsersPermissionRemoved: KeyIcon,
    siteSharingCapabilityUpdated: LockIcon,
    siteFileVersionsTrimmed: ScissorsIcon,
    siteFileVersionPolicyUpdated: SettingsIcon,
    tenantFileVersionPolicyUpdated: SettingsIcon,
    documentLibraryFileVersionPolicyUpdated: SettingsIcon,
    documentLibraryFileVersionsTrimmed: ScissorsIcon,
    reportShareCreated: ShareIcon,
    reportShareRecipientsAdded: AddUserIcon,
    reportShareRecipientsRemoved: RemoveUserIcon,
    reportShareRevoked: RemoveIcon,
    reportShareExpiryChanged: CalendarIcon,
    reportShareRenamed: EditIcon,
    reportShareDeleted: DeleteIcon,
    fileArchived: ArchiveIcon,
    fileDeleted: DeleteIcon,
    sharingLinkRecipientRemoved: RemoveUserIcon,
    unknown: MinusIcon
} satisfies Record<ODataActivityType, ComponentType>;

// The manage* and addGroupUsers actions have no activity type of their own; they borrow the add icon.
export const BULK_ACTION_ACTIVITY_TYPE = {
    deleteSharingLink: "sharingLinkDeleted",
    addGroupOwner: "groupOwnerAdded",
    removeGroupOwner: "groupOwnerRemoved",
    manageGroupOwners: "groupOwnerAdded",
    deleteGroup: "groupDeleted",
    removeGroupGuest: "groupGuestRemoved",
    updateGroupVisibility: "groupVisibilityUpdated",
    deleteSite: "siteDeleted",
    archiveSite: "siteArchived",
    deleteArchivedSite: "archivedSiteDeleted",
    unassignUserLicense: "userLicenseUnassigned",
    removeEveryoneExceptExternalUsersPermission: "everyoneExceptExternalUsersPermissionRemoved",
    updateSiteSharingCapability: "siteSharingCapabilityUpdated",
    trimSiteFileVersions: "siteFileVersionsTrimmed",
    updateSiteFileVersionPolicy: "siteFileVersionPolicyUpdated",
    updateTenantFileVersionPolicy: "tenantFileVersionPolicyUpdated",
    addGroupMember: "groupMemberAdded",
    manageGroupUsers: "groupMemberAdded",
    removeGroupMember: "groupMemberRemoved",
    removeDirectPermission: "directPermissionRemoved",
    removePrincipalFromSPGroup: "principalRemovedFromSPGroup",
    updateDocumentLibraryFileVersionPolicy: "documentLibraryFileVersionPolicyUpdated",
    addGroupUsers: "groupMemberAdded",
    trimDocumentLibraryFileVersions: "documentLibraryFileVersionsTrimmed",
    removeSiteCollectionAdmin: "siteCollectionAdminRemoved",
    archiveFile: "fileArchived",
    deleteFile: "fileDeleted",
    removeSharingLinkRecipient: "sharingLinkRecipientRemoved"
} as const satisfies Record<BulkAction, ODataActivityType>;
